export default class LocationDTO {
  constructor (data = {}) {
    this.locationId = data.location_id || null
    this.legacyLocationId = data.legacy_location_id || null
    this.practiceId = data.practice_id || null
    this.legacyPracticeId = data.legacy_practice_id || null
    this.name = data.name || null
    this.telephone = data.telephone || null
    this.inquiryPhone = data.inquiry_phone || null
    this.fax = data.fax || null
    this.email = data.email || null
    this.addressNumber = data.address_number || null
    this.addressStreet = data.address_street || null
    this.address2 = data.address2 || null
    this.city = data.city || null
    this.neighborhood = data.neighborhood || null
    this.state = data.state || null
    this.zip = data.zip || null
    this.timezone = data.timezone || null
    this.parkingInstructions = data.parking_instructions || null
    this.externalLocationId = data.external_location_id || null
    this.latitude = data.latitude || null
    this.longitude = data.longitude || null
    this.staticCallTrackingNumber = data.static_call_tracking_number || null
    this.isPaid = data.is_paid || null
    this.createdAt = data.created_at || null
    this.updatedAt = data.updated_at || null
  }
}
